module.exports = __webpack_public_path__ + "static/media/generic_phone_shell.dfa52205.png";